export default function ChecklistModelDecorator($provide) {
    'ngInject';

    $provide.decorator('checklistModelDirective', ['$parse', '$compile', '$delegate',
        function($parse, $compile, $delegate) {
            const directive = $delegate[0];

            function contains(arr, item) {
                if (angular.isArray(arr)) {
                    for (let i = 0; i < arr.length; i++) {
                        if (angular.equals(arr[i], item)) {
                            return true;
                        }
                    }
                }
                return false;
            }

            function add(arr, item) {
                for (let i = 0; i < arr.length; i++) {
                    if (angular.equals(arr[i], item)) {
                        return arr;
                    }
                }
                arr.push(item);
                return arr;
            }

            function remove(arr, item) {
                if (angular.isArray(arr)) {
                    for (let i = 0; i < arr.length; i++) {
                        if (angular.equals(arr[i], item)) {
                            arr.splice(i, 1);
                            break;
                        }
                    }
                }

                return arr;
            }

            function postLinkFn(scope, elem, attrs) {
                // compile with `ng-model` pointing to `checked`
                $compile(elem)(scope);

                // getter / setter for original model
                const getter = $parse(attrs.checklistModel);
                const setter = getter.assign;

                // value added to list
                let value = $parse(attrs.checklistValue)(scope.$parent);

                // watch UI checked change
                scope.$watch('checked', function(newValue, oldValue) {
                    if (newValue === oldValue) {
                        return;
                    }

                    const current = getter(scope.$parent);

                    if (newValue === true) {
                        setter(scope.$parent, add(current || [], value));
                    } else {
                        setter(scope.$parent, remove(current, value));
                    }
                });

                // watch original model change
                scope.$parent.$watch(attrs.checklistModel, function(newArr) {
                    scope.checked = contains(newArr, value);
                }, true);

                scope.$parent.$watch(attrs.checklistValue, function(newValue) {
                    value = newValue;
                    scope.checked = contains(getter(scope.$parent), value);
                });
            }

            directive.compile = function(tElement, tAttrs) {
                if (!tAttrs.checklistValue) {
                    throw new Error('You should provide `checklist-value`.');
                }

                // exclude recursion
                tElement.removeAttr('checklist-model');

                // local scope var storing individual checkbox model
                tElement.attr('ng-model', 'checked');

                return postLinkFn;
            };

            return $delegate;
        },
    ]);
}



// WEBPACK FOOTER //
// ./src/app/directives/checklistModel.decorator.js